// import { memo, useCallback, useEffect, useState } from 'react';
// import { Box, Button, Card, CircularProgress, FormControl, FormControlLabel, Grid, IconButton, InputAdornment, InputLabel, MenuItem, Radio, RadioGroup, Select, Skeleton, TextField, Typography } from "@mui/material";
// import { useInView } from 'react-intersection-observer';
// import { IoIosArrowRoundBack } from 'react-icons/io';
// import { RiSearchLine } from 'react-icons/ri';
// import DataTable from 'react-data-table-component';
// import { useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { usePaginatedQuery } from '../../utils/usePagination';
// import { CustomPagination } from '../../pages/AdminPages/AdminComponents/CustomTable';
// import { useTQuery } from '../../utils/useTQuery';
// import { setTableUse } from '../../slice/tableViewSlice';
// import Tabs from './Tabs';
// import { useQueryTable } from '../../utils/useTQueryTable';
// import { useQueryClient } from '@tanstack/react-query';
// import { useDebounce } from '../../hooks/useDebounce';
// import "./customTable.css";

// // Skeleton components
// const GridSkeleton = ({ columns }) => (
//   <Box sx={{ width: '100%' }}>
//     {Array(10).fill().map((_, index) => (
//       <Box key={index} display="flex" p={1} borderBottom="1px solid #eee">
//         {columns.map((col, colIndex) => (
//           <Box key={colIndex} flex={1} px={1}>
//             <Skeleton variant="text" width="100%" height={40} />
//           </Box>
//         ))}
//       </Box>
//     ))}
//   </Box>
// );

// const CardSkeleton = () => (
//   <Grid container spacing={3}>
//     {Array(6).fill().map((_, index) => (
//       <Grid item xs={12} sm={6} md={4} key={index}>
//         <Card sx={{ p: 2, height: '180px' }}>
//           <Skeleton variant="rectangular" width="60%" height={30} sx={{ mb: 2 }} />
//           <Skeleton variant="rectangular" width="40%" height={25} sx={{ mb: 1.5 }} />
//           <Skeleton variant="rectangular" width="80%" height={20} sx={{ mb: 1 }} />
//           <Skeleton variant="rectangular" width="70%" height={20} sx={{ mb: 1 }} />
//           <Skeleton variant="rectangular" width="50%" height={20} />
//         </Card>
//       </Grid>
//     ))}
//   </Grid>
// );

// export const CustomTable = memo(({ url, searchField, column, cardView, tabs, event, userType, CardViewCustomUi, filterTabs, ...props }) => {
//   // console.log("tabs", url, searchField, column, cardView, tabs, userType, CardViewCustomUi, filterTabs,);
//   const navigate = useNavigate();
//   const { userDetails } = useSelector((state) => state.user);
//   const [showSort, setShowSort] = useState(false);
//   const [active, setActive] = useState(tabs ? tabs[0] : "");
//   const [searchValues, setSearchValues] = useState("");
//   const [values, setValues] = useState({
//     ...props?.payload,
//     ID: userDetails?.ID,
//     USER_TYPE: userType ? userType : userDetails?.USER_TYPE,
//     FILTER_VALUE: "",
//     SEARCH_PARMETER_LIST: ["USER_TYPE", "EMAIL_ADDRESS", "USER_STATUS"],
//   });
//   const { table: team } = useSelector((state) => state?.tableView);
//   const [table, setTable] = useState(team);
//   const dispatch = useDispatch();
//   const [customFetch, setCustomFetch] = useState(false);
//   const [paginationData, setPaginationData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const queryClient = useQueryClient();
//   const debouncedSearch = useDebounce(searchValues, 500);

//   useEffect(() => {
//     setValues((prev) => ({
//       ...prev,
//       FILTER_VALUE: debouncedSearch,
//     }));
//   }, [debouncedSearch]);

//   useEffect(() => {
//     setValues({ ...values, ...props?.payload });
//   }, [props?.payload]);

//   const { ref, inView } = useInView({
//     threshold: 1.0, // Trigger when the element is fully visible
//   });
//   //For Grid

//   useEffect(() => {
//     return () => {
//       queryClient.removeQueries(["user-management-grid"]);
//       queryClient.removeQueries(["user-management-card"]);
//     };
//   }, [queryClient]);

//   const {
//     fetchNextPage,
//     data,
//     refetch,
//     hasNextPage,
//     isFetchingNextPage,
//     isLoading,
//     isError,
//   } = usePaginatedQuery({
//     queryKey: ["user-management-card"],
//     url: active.url ? active.url : url,
//     enabled: table === "cardView" ? true : false,
//     initialData: undefined, // Prevent stale data flash
//     parmeter: { ...values, ...active?.body },
//   });
//   // console.log("data?.pages", data?.pages?.[0]?.OUTPUT);
//   useEffect(() => {
//     if (!customFetch) {
//       if (inView && hasNextPage && !isFetchingNextPage) {
//         // console.log("sdddd", data?.pageParams.length + 1, data.pages[0]?.meta?.totalPages)
//         if (data?.pageParams.length !== data.pages[0]?.meta?.totalPages) {
//           fetchNextPage();
//         }
//       }
//     } else {
//       refetch();
//       setCustomFetch(false);
//     }
//   }, [customFetch, inView, fetchNextPage, hasNextPage, isFetchingNextPage]);

//   useEffect(() => {
//     const field = column
//       .filter((data) => data.valuesName)
//       .map((data) => data.valuesName);
//     setValues((prev) => ({ ...prev, SEARCH_PARMETER_LIST: field }));
//   }, [column]);

//   // const [pagination, setPagination] = useState({
//   //   page: 1, // Zero-based for the first page
//   //   rowsPerPage: 10,
//   //   totalPage: 0,
//   // });
//   const [pagination, setPagination] = useState({
//     page: 1,
//     rowsPerPage: 10,
//     totalPage: 0,
//     totalItems: 0,
//   });

//   //For Grid

//   const query = useQueryTable({
//     key: ["user-management-grid", values.FILTER_VALUE],
//     url: `${active.url ? active.url : url}`,
//     method: "get",
//     enabled: table === "gridView",
//     keepPreviousData: false, // Avoid showing old data
//     appendQueryParams: {
//       ...values,
//       ...active?.body,
//       page: pagination.page,
//       rowsPerPage: pagination.rowsPerPage,
//     },
//   });

//   useEffect(() => {
//     if (!active.customUi) {
//       setLoading(true); // Show loading when tab changes

//       if (table === "gridView") {
//         query.refetch().finally(() => setLoading(false)); // Hide loading when done
//       } else if (table === "cardView") {
//         refetch().finally(() => setLoading(false)); // Hide loading when done
//       }
//     }
//   }, [active, table, values, pagination.page, pagination.rowsPerPage]);

//   const handleSort = useCallback((column, sortDirection) => {
//     setValues({
//       ...values,
//       DIRECTION: sortDirection,
//       FIELD: column.valuesName,
//     });
//     query?.refetch();
//   }, []);

//   useEffect(() => {
//     if (query?.data) {
//       setPaginationData(query?.data?.OUTPUT);
//       // event(query)
//       event({ query, activeTab: active });
//       setPagination((prev) => ({
//         ...prev,

//         // rowsPerPage: query?.data?.meta?.pageSize ?? 10,
//         // totalPage: query?.data?.meta?.totalItems ?? 0,
//         rowsPerPage: query.data.meta.pageSize ?? 10,
//         totalPage: query.data.meta.totalPages ?? 0,
//         totalItems: query.data.meta.totalItems ?? 0,
//         page: query.data.meta.currentPage ?? prev.page,
//       }));
//     } else {
//       setPaginationData([]);
//       event({ query: {}, activeTab: active });
//     }
//   }, [active]);
//   // active, event, query, query?.data, query?.data?.meta?.pageSize

//   useEffect(() => {
//     // query?.refetch();
//     setCustomFetch(true)
//   }, [values.FILTER_VALUE, values.DIRECTION, values.FIELD, debouncedSearch]);

//   // useEffect(() => {
//   //   if (table == "cardView")
//   //     refetch()
//   // }, [values.FILTER_VALUE])

//   const handleShortChange = (name) => (event) => {
//     setValues({ ...values, [name]: event.target.value });
//   };
//   const handleTabChange = (data) => {
//     // console.log("handleTabChange data", data)
//     setLoading(true); // Show loading when tab changes
//     setActive(data);
//   };

//   return (
//     <>
//       <Card className="responsive-table-col">
//         <Grid px={1.5}>
//           {props?.headline && (
//             <Grid
//               container
//               justifyContent={"space-between"}
//               sx={{ padding: "10px 0px" }}
//             >
//               <Grid item>
//                 <Typography
//                   mt={1.2}
//                   variant="h2"
//                   component="div"
//                   fontWeight={"bold"}
//                 >
//                   {props?.headline}
//                 </Typography>
//               </Grid>
//             </Grid>
//           )}

//           <Grid
//             container
//             className="table-actions-row"
//             justifyContent={"space-between"}
//             sx={{ padding: "2px 0px", alignItems: "center" }}
//           >
//             <Grid item>
//               <RadioGroup
//                 row
//                 aria-label="position"
//                 name="position"
//                 padding={10}
//                 sx={{ marginTop: 0.7 }}
//                 value={table}
//                 onChange={(e) => {
//                   setTable(e.target.value);
//                   dispatch(setTableUse(e.target.value));
//                 }}
//                 defaultValue="top"
//               >
//                 <FormControlLabel
//                   value="cardView"
//                   control={<Radio />}
//                   label="Card View"
//                 />
//                 <FormControlLabel
//                   value="gridView"
//                   control={<Radio />}
//                   label="List View"
//                 />
//               </RadioGroup>
//             </Grid>
//             <Grid display={"flex"}>
//               {props.back && (
//                 <Grid item>
//                   <Box
//                     // sx={{ display: "flex", alignItems: "center", cursor: "pointer", mr: 2, }}
//                     sx={{
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center", // Ensures the position remains consistent

//                       cursor: "pointer",
//                       gap: 1, // Adds spacing between the icon and text
//                       width: "100%", // Ensures it adapts to container width
//                       padding: "8px 16px", // Adjusts padding for consistent spacing
//                       mr: 2,
//                     }}
//                     onClick={() => navigate(props.back)}
//                   >
//                     <IconButton className="" style={{ color: "#6ebe44" }}>
//                       <IoIosArrowRoundBack />
//                     </IconButton>
//                     <Typography
//                       variant="body1"
//                       className="backcustom"
//                       style={{ color: "#6ebe44" }}
//                     >
//                       Back
//                     </Typography>
//                   </Box>
//                 </Grid>
//               )}

//               {props?.add && (
//                 <Grid item mt={1}>
//                   <Button
//                     className="custombutton"
//                     variant="contained"
//                     onClick={() => navigate(props?.add)}
//                     sx={{ background: "#6EBE44" }}
//                   >
//                     {props.buttonText ? props.buttonText : "Add"}
//                   </Button>
//                 </Grid>
//               )}
//               {props?.customButton && <>{props?.customButton}</>}
//             </Grid>
//           </Grid>

//           <Grid item lg={12}>
//             <Grid container columnSpacing={1.5} sx={{ padding: "10px" }}>
//               {tabs &&
//                 tabs.map((data) => {
//                   return (
//                     <Grid item>
//                       <Tabs
//                         title={data.title}
//                         active={data.title === active?.title}
//                         onClick={() => handleTabChange(data)}
//                       />
//                     </Grid>
//                   );
//                 })}
//               {filterTabs && <Grid item>{filterTabs}</Grid>}

//               {!active?.customUi ? (
//                 <>
//                   {" "}
//                   {!table === "gridView" && (
//                     <>
//                       <Grid item lg={1} px={2}>
//                         <Button
//                           className="custombutton"
//                           variant="outlined"
//                           onClick={() => setShowSort(!showSort)}
//                         >
//                           {" "}
//                           Sort
//                         </Button>
//                       </Grid>
//                       {showSort && (
//                         <>
//                           <Grid item lg={2}>
//                             <FormControl fullWidth>
//                               <InputLabel
//                                 id="work-type-status-select-label"
//                                 style={{ fontSize: "14px" }}
//                               >
//                                 Select Field
//                               </InputLabel>
//                               <Select
//                                 labelId="work-type-status-select-label"
//                                 id="work-type-status-select"
//                                 label="Work Type Status"
//                                 value={values.FIELD}
//                                 onChange={handleShortChange("FIELD")}
//                               >
//                                 {column.map(
//                                   (val) =>
//                                     val.name !== "Actions" && (
//                                       <MenuItem
//                                         key={val.valuesName}
//                                         value={val.valuesName}
//                                       >
//                                         {val.name}
//                                       </MenuItem>
//                                     )
//                                 )}
//                               </Select>
//                             </FormControl>
//                           </Grid>

//                           <Grid item lg={2}>
//                             <FormControl fullWidth>
//                               <InputLabel
//                                 id="work-type-status-select-label"
//                                 style={{ fontSize: "14px" }}
//                               >
//                                 Select Sorting Type
//                               </InputLabel>
//                               <Select
//                                 labelId="work-type-status-select-label"
//                                 id="work-type-status-select"
//                                 label="Work Type Status"
//                                 value={values.DIRECTION}
//                                 onChange={handleShortChange("DIRECTION")}
//                               >
//                                 <MenuItem value="ASC">ASC</MenuItem>
//                                 <MenuItem value="DESC">DESC</MenuItem>
//                               </Select>
//                             </FormControl>
//                           </Grid>
//                         </>
//                       )}
//                     </>
//                   )}
//                   <Grid
//                     container
//                     display="flex"
//                     justifyContent="end"
//                     className="search-input-col"
//                     style={{ marginTop: "10px" }}
//                   >
//                     {props?.options && (
//                       <Grid item xs={4} md={4}>
//                         {props.options}
//                       </Grid>
//                     )}
//                     <Grid item>
//                       <TextField
//                         placeholder="Search"
//                         variant="outlined"
//                         size="small"
//                         style={{
//                           position: "relative",
//                           left: "10px",
//                         }}
//                         sx={{
//                           "& .MuiOutlinedInput-input": {
//                             padding: 1.85,
//                           },
//                         }}
//                         value={searchValues}
//                         onChange={(e) => setSearchValues(e.target.value)}
//                         // value={values.FILTER_VALUE}
//                         // onChange={(e) => {
//                         //   e.preventDefault();
//                         //   // setValues(prev => ({ ...prev, FILTER_VALUE: e.target.value }));
//                         //   setTimeout(() => {
//                         //     setDebouncedSearch(searchValues); // Update only after delay
//                         //   }, 500);
//                         // }}
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <RiSearchLine />
//                             </InputAdornment>
//                           ),
//                         }}
//                       />
//                     </Grid>
//                   </Grid>
//                 </>
//               ) : (
//                 <>{tabs[0]?.element}</>
//               )}
//             </Grid>

//             {table === "gridView" && !active?.customUi && (
//               <>
//                 {query.isLoading ? (
//                   <GridSkeleton
//                     columns={active?.column ? active.column : column}
//                   />
//                 ) : (
//                   <>
//                     <DataTable
//                       className="table-items"
//                       columns={active?.column ? active?.column : column}
//                       data={query?.data?.OUTPUT}
//                       onSort={handleSort}
//                       sortServer
//                     />
//                     <Grid item>
//                       <CustomPagination
//                         pagination={pagination}
//                         count={pagination?.totalItems}
//                         rowsPerPage={pagination.rowsPerPage}
//                         page={pagination.page - 1}
//                         setPage={(newPage) => {
//                           setPagination((prev) => ({
//                             ...prev,
//                             page: newPage + 1,
//                           }));
//                         }}
//                         onChangePage={(newPage) => {
//                           setPagination((prev) => ({
//                             ...prev,
//                             page: newPage + 1,
//                           }));
//                         }}
//                         onChangeRowsPerPage={(rowsPerPage) =>
//                           setPagination((prev) => ({
//                             ...prev,
//                             rowsPerPage,
//                             page: 1,
//                           }))
//                         }
//                       />
//                     </Grid>
//                   </>
//                 )}
//               </>
//             )}
//           </Grid>
//         </Grid>

//         {/* Old Code  */}

//         {/* Commented by Anuj Apr22 2025 */}

//         {/* 
//        {table === "cardView" && !active?.customUi && (

//         <Grid className='gridcard grid_card_data' px={1.5} py={4} container columnSpacing={2.5} rowSpacing={3.5}
//           style={{ overflowY: 'auto' }}
//         >
//           {isLoading ? (
//             <CardSkeleton />
//           ) : (
//             data?.pages.flatMap(page => page.OUTPUT).map((val, index) => (
//               <Grid item ref={ref} lg={4} key={index}>
//                 {CardViewCustomUi ? CardViewCustomUi(val) : (

//                   <Card sx={{
//                     borderRadius: 1,
//                     boxShadow: "2px 2px 3px 3px #4CAF50",
//                     display: 'flex',
//                     flexDirection: 'column',
//                     justifyContent: 'space-between',
//                     minHeight: '180px',
//                     position: "relative",
//                     top: -57
//                   }}>
//                     {column.map(col => (
//                       <>
//                         {col?.heading && !col?.button && (
//                           <Typography variant="h6" fontWeight="bold">
//                             {col?.selector(val)}
//                           </Typography>
//                         )}
//                         {col?.status && !col?.button && (
//                           <Typography variant="h6" fontWeight="bold" mt={1}>
//                             <span style={{
//                               background: "#d2fbe5",
//                               color: "green",
//                               padding: "5px 10px",
//                               borderRadius: "20px",
//                               whiteSpace: 'nowrap',
//                               overflow: 'hidden',
//                               textOverflow: 'ellipsis',
//                               maxWidth: '150px'
//                             }}>
//                               {col?.selector(val)}
//                             </span>
//                           </Typography>
//                         )}
//                         {!col.status && !col.heading && !col?.button && (
//                           <Grid mt={1}>
//                             <div className='dflex' style={{ width: "100%" }}>
//                               <div style={{ width: "30%" }}>
//                                 <p className='inter-family bold' style={{ fontSize: "11.4px" }}>
//                                   {col.name}
//                                 </p>
//                               </div>
//                               <div style={{ width: "50%" }}>
//                                 <p className='inter-family' style={{
//                                   fontSize: "11.4px",
//                                   whiteSpace: "normal",
//                                   wordWrap: "break-word",
//                                   overflowWrap: "break-word",
//                                   paddingLeft: "11px",
//                                   minWidth: "200px"
//                                 }}>
//                                   {col?.selector(val, index)}
//                                 </p>
//                               </div>
//                             </div>
//                           </Grid>
//                         )}
//                         {col?.button && (
//                           <div key={col.name} style={{ display: "flex", justifyContent: "end", marginTop: 2 }}>
//                             {col.cell ? col.cell(val) : null}
//                           </div>
//                         )}
//                       </>
//                     ))}
//                   </Card>
//                 )}
//               </Grid>


//             ))
//           )}
//         </Grid>
//       )}  */}

//         {/* Latest Code */}
//         {/* Created by Anuj 22 Apr 2025 */}
//         {table === "cardView" && !active?.customUi && (
//           <Grid
//             className="gridcard grid_card_data clinicians-card-row"
//             px={1.5}
//             py={4}
//             container
//             columnSpacing={2.5}
//             rowSpacing={3.5}
//             style={{ overflowY: "auto" }}
//           >
//             {isLoading ? (
//               <CardSkeleton />
//             ) : (
//               <>
//                 {data?.pages?.[0]?.OUTPUT?.length === 0 ? (
//                   <Grid
//                     item
//                     xs={12}
//                     style={{ textAlign: "center", width: "100%" }}
//                   >
//                     <Typography
//                       variant="h6"
//                       sx={{
//                         fontStyle: "normal",
//                         fontWeight: 400,
//                         fontSize: "16px",
//                         lineHeight: "24px",
//                         color: "#000000",
//                       }}
//                     >
//                       There are no records to display
//                     </Typography>
//                   </Grid>
//                 ) : (
//                   data.pages
//                     .flatMap((page) => page.OUTPUT)
//                     .map((val, index) => (
//                       <Grid item ref={ref} lg={4} key={index}>
//                         {CardViewCustomUi ? (
//                           CardViewCustomUi(val)
//                         ) : (
//                           <Card
//                             className="clinician-cards-col"
//                             sx={{
//                               borderRadius: 1,
//                               boxShadow: "2px 2px 3px 3px #4CAF50",
//                               display: "flex",
//                               flexDirection: "column",
//                               justifyContent: "space-between",
//                               minHeight: "180px",
//                               // position: "relative",
//                               // top: -57
//                             }}
//                           >
//                             <>
//                               {column.map((col, colIndex) => (
//                                 <>
//                                   {col?.heading && !col?.button && (
//                                     <Typography
//                                       variant="h6"
//                                       fontWeight="bold"
//                                       key={colIndex}
//                                     >
//                                       {col?.selector(val)}
//                                     </Typography>
//                                   )}
//                                   {col?.status && !col?.button && (
//                                     <Typography
//                                       variant="h6"
//                                       fontWeight="bold"
//                                       mt={1}
//                                       key={colIndex}
//                                     >
//                                       <span
//                                         style={{
//                                           background: "#d2fbe5",
//                                           color: "green",
//                                           padding: "5px 10px",
//                                           borderRadius: "20px",
//                                           whiteSpace: "nowrap",
//                                           overflow: "hidden",
//                                           textOverflow: "ellipsis",
//                                           maxWidth: "150px",
//                                         }}
//                                       >
//                                         {col?.selector(val)}
//                                       </span>
//                                     </Typography>
//                                   )}
//                                   {!col.status &&
//                                     !col.heading &&
//                                     !col?.button && (
//                                       <Grid mt={1} key={colIndex}>
//                                         <div
//                                           className="dflex"
//                                           style={{ width: "100%" }}
//                                         >
//                                           <div style={{ width: "30%" }}>
//                                             <p
//                                               className="inter-family bold"
//                                               style={{ fontSize: "11.4px" }}
//                                             >
//                                               {col.name}
//                                             </p>
//                                           </div>
//                                           <div style={{ width: "50%" }}>
//                                             <p
//                                               className="inter-family"
//                                               style={{
//                                                 fontSize: "11.4px",
//                                                 whiteSpace: "normal",
//                                                 wordWrap: "break-word",
//                                                 overflowWrap: "break-word",
//                                                 paddingLeft: "11px",
//                                                 minWidth: "200px",
//                                               }}
//                                             >
//                                               {col?.selector(val, index)}
//                                             </p>
//                                           </div>
//                                         </div>
//                                       </Grid>
//                                     )}
//                                   {col?.button && (
//                                     <div
//                                       key={col.name}
//                                       style={{
//                                         display: "flex",
//                                         justifyContent: "end",
//                                         marginTop: 2,
//                                       }}
//                                     >
//                                       {col.cell ? col.cell(val) : null}
//                                     </div>
//                                   )}
//                                 </>
//                               ))}
//                             </>
//                           </Card>
//                         )}
//                       </Grid>
//                     ))
//                 )}
//               </>
//             )}
//           </Grid>
//         )}
//       </Card>
//     </>
//   );
// });

// export default CustomTable;


import { memo, useCallback, useEffect, useState } from 'react';
import { Box, Button, Card, CircularProgress, FormControl, FormControlLabel, Grid, IconButton, InputAdornment, InputLabel, MenuItem, Radio, RadioGroup, Select, Skeleton, TextField, Typography } from "@mui/material";
import { useInView } from 'react-intersection-observer';
import { IoIosArrowRoundBack } from 'react-icons/io';
import { RiSearchLine } from 'react-icons/ri';
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { usePaginatedQuery } from '../../utils/usePagination';
import { CustomPagination } from '../../pages/AdminPages/AdminComponents/CustomTable'; // Assuming this path is correct for your CustomPagination
import { useTQuery } from '../../utils/useTQuery';
import { setTableUse } from '../../slice/tableViewSlice';
import Tabs from './Tabs';
import { useQueryTable } from '../../utils/useTQueryTable'; // Assuming this path is correct for useQueryTable
import { useQueryClient } from '@tanstack/react-query';
import { useDebounce } from '../../hooks/useDebounce';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { RiCalendar2Line } from "react-icons/ri";
import dayjs, { Dayjs } from "dayjs";
import "./customTable.css";

// Skeleton components
const GridSkeleton = ({ columns }) => (
  <Box sx={{ width: '100%' }}>
    {Array(10).fill().map((_, index) => (
      <Box key={index} display="flex" p={1} borderBottom="1px solid #eee">
        {columns.map((col, colIndex) => (
          <Box key={colIndex} flex={1} px={1}>
            <Skeleton variant="text" width="100%" height={40} />
          </Box>
        ))}
      </Box>
    ))}
  </Box>
);

const CardSkeleton = () => (
  <Grid container spacing={3}>
    {Array(6).fill().map((_, index) => (
      <Grid item xs={12} sm={6} md={4} key={index}>
        <Card sx={{ p: 2, height: '180px' }}>
          <Skeleton variant="rectangular" width="60%" height={30} sx={{ mb: 2 }} />
          <Skeleton variant="rectangular" width="40%" height={25} sx={{ mb: 1.5 }} />
          <Skeleton variant="rectangular" width="80%" height={20} sx={{ mb: 1 }} />
          <Skeleton variant="rectangular" width="70%" height={20} sx={{ mb: 1 }} />
          <Skeleton variant="rectangular" width="50%" height={20} />
        </Card>
      </Grid>
    ))}
  </Grid>
);

export const CustomTable = memo(({ url, searchField, column, cardView, tabs, event, userType, CardViewCustomUi, filterTabs, jobSchedule, filter, filterValues, overrideFilterValue, hideSearchBox, ...props }) => {
  const navigate = useNavigate();
  const { userDetails } = useSelector((state) => state.user);
    console.log("CustomTable -> props.ID:", );
  const [showSort, setShowSort] = useState(false);
  const [active, setActive] = useState(tabs ? tabs[0] : "");
  const [searchValues, setSearchValues] = useState("");
  const [values, setValues] = useState({
    ...props?.payload,
    ID: props?.payload?.ID || userDetails?.ID,
    USER_TYPE: userType ? userType : userDetails?.USER_TYPE,
    FILTER_VALUE: "",
    SEARCH_PARMETER_LIST: ["USER_TYPE", "EMAIL_ADDRESS", "USER_STATUS"],
  });
  const { table: team } = useSelector((state) => state?.tableView);
  const [table, setTable] = useState(team);
  const dispatch = useDispatch();
  const [customFetch, setCustomFetch] = useState(false);
  const [paginationData, setPaginationData] = useState([]);
  const [loading, setLoading] = useState(false);
  const queryClient = useQueryClient();
  const debouncedSearch = useDebounce(searchValues, 500);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isSelectingStart, setIsSelectingStart] = useState(true);



  useEffect(() => {
    setValues((prev) => ({
      ...prev,
      FILTER_VALUE:
        overrideFilterValue !== undefined && overrideFilterValue !== null
          ? overrideFilterValue
          : debouncedSearch,
    }));
  }, [debouncedSearch, overrideFilterValue]);

  // Reset internal search and date state when parent triggers a resetKey change
  useEffect(() => {
    if (props?.resetKey !== undefined) {
      setSearchValues("");
      setStartDate(null);
      setEndDate(null);
    }
  }, [props?.resetKey]);

  useEffect(() => {
    setValues({ ...values, ...props?.payload });
  }, [props?.payload]);

  const { ref, inView } = useInView({
    threshold: 1.0, // Trigger when the element is fully visible
  });

  useEffect(() => {
    return () => {
      queryClient.removeQueries(["user-management-grid"]);
      queryClient.removeQueries(["user-management-card"]);
    };
  }, [queryClient]);

  const {
    fetchNextPage,
    data,
    refetch,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    isError,
  } = usePaginatedQuery({
    queryKey: ["user-management-card"],
    url: active.url ? active.url : url,
    enabled: table === "cardView",
    initialData: undefined, // Prevent stale data flash
    parmeter: { ...values, ...active?.body },
  });


  const schedule = data?.pages[0]?.OUTPUT[0]?.jobSchedule

  if (typeof jobSchedule === 'function') {
    jobSchedule(schedule);
  }
  

useEffect(() => {
  setValues((prev) => ({
    ...prev,
    jobStartDate: startDate ? dayjs(startDate).format("YYYY-MM-DD") : "",
    jobEndDate: endDate ? dayjs(endDate).format("YYYY-MM-DD") : "",
  }));
}, [startDate, endDate, setValues]);


  useEffect(() => {
    if (!customFetch) {
      if (table === "cardView" && inView && hasNextPage && !isFetchingNextPage) {
        if (data?.pageParams.length !== data.pages[0]?.meta?.totalPages) {
          fetchNextPage();
        }
      }
    } else {
      // customFetch is only used for cardView manual refetches
      if (table === "cardView") {
        refetch();
      }
      setCustomFetch(false);
    }
  }, [customFetch, inView, hasNextPage, isFetchingNextPage, data, table, fetchNextPage, refetch]);

 useEffect(() => {
  const field = column
    .filter((data) => data.valuesName)
    .map((data) => data.valuesName);

  const finalField =
    Array.isArray(filterValues) && filterValues.length > 0
      ? filterValues
      : field;

  setValues((prev) => ({
    ...prev,
    SEARCH_PARMETER_LIST: filter
      ? (startDate || endDate ? finalField : finalField)
      : finalField,
  }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [column, startDate, endDate, JSON.stringify(filterValues)]);


  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 10,
    totalPage: 0,
    totalItems: 0,
  });

  const query = useQueryTable({
    key: ["user-management-grid", values.FILTER_VALUE, values.FIELD, values.DIRECTION],
    url: `${active.url ? active.url : url}`,
    method: "get",
    enabled: table === "gridView",
    keepPreviousData: false,
    appendQueryParams: {
      ...values,
      ...active?.body,
      page: pagination.page,
      rowsPerPage: pagination.rowsPerPage,
    },
  });


  useEffect(() => {
    if (!active.customUi) {
      setLoading(true);
      if (table === "gridView") {
        query.refetch().finally(() => setLoading(false));
      } else if (table === "cardView") {
        refetch().finally(() => setLoading(false));
      }
    }
  }, [active, table, values, pagination.page, pagination.rowsPerPage]);

  const handleSort = useCallback((columnObj, sortDirection) => {
    // Get the column definitions from either active tab or main column prop
    const allColumns = active?.column || column;
    
    let fieldName = columnObj.valuesName;
    
    if (Array.isArray(allColumns)) {
      // Try to match by valuesName first (most reliable)
      let matchedColumn = allColumns.find(col => col.valuesName === columnObj.valuesName);
      
      // If not found, try matching by comparing selector functions
      if (!matchedColumn && columnObj.selector) {
        const columnObjSelectorStr = columnObj.selector?.toString?.() || '';
        matchedColumn = allColumns.find(col => {
          const colSelectorStr = col.selector?.toString?.() || '';
          return colSelectorStr === columnObjSelectorStr;
        });
      }
      
      // If still not found, try matching by name (for string names)
      if (!matchedColumn && typeof columnObj.name === 'string') {
        matchedColumn = allColumns.find(col => {
          const colName = typeof col.name === 'string' ? col.name : '';
          return colName === columnObj.name;
        });
      }
      
      fieldName = matchedColumn?.valuesName || columnObj.valuesName;
      console.log('Matched column:', matchedColumn?.name || 'Not found', 'Field:', fieldName);
    }
    
    setValues((prevValues) => ({
      ...prevValues,
      DIRECTION: sortDirection,
      FIELD: fieldName,
    }));
    // Reset to first page when sorting
    setPagination((prev) => ({
      ...prev,
      page: 1,
    }));
  }, [active, column]); // Added active and column to dependencies

  useEffect(() => {
    if (query?.data) {
      setPaginationData(query?.data?.OUTPUT);
      event({ query, activeTab: active });
      setPagination((prev) => ({
        ...prev,
        rowsPerPage: query?.data?.meta?.pageSize ?? 10,
        totalPage: query?.data?.meta?.totalPages ?? 0,
        totalItems: query?.data?.meta?.totalItems ?? 0,
        page: query?.data?.meta?.currentPage ?? prev.page,
      }));
    } else {
      setPaginationData([]);
      event({ query, activeTab: active });
    }
  }, [active, query?.data]); // FIX: Added query.data to dependencies

  useEffect(() => {
    // For card (infinite scroll) view we drive refetches manually via customFetch.
    // For grid view, React Query's own dependency tracking is enough, to avoid duplicate calls.
    if (table === "cardView") {
      setCustomFetch(true);
    }
  }, [table, values.FILTER_VALUE, values.DIRECTION, values.FIELD, debouncedSearch]);

  const handleShortChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value });
  };

  const handleTabChange = (data) => {
    setLoading(true);
    setActive(data);
  };

  const handleResetFilters = () => {
    setSearchValues("");
    setStartDate(null);
    setEndDate(null);
  };

  return (
    <>
      <Card className="responsive-table-col">
        <Grid px={1.5}>
          {props?.headline && (
            <Grid
              container
              justifyContent={"space-between"}
              sx={{ padding: "10px 0px" }}
            >
              <Grid item>
                <Typography
                  mt={1.2}
                  variant="h2"
                  component="div"
                  fontWeight={"bold"}
                >
                  {props?.headline}
                </Typography>
              </Grid>
            </Grid>
          )}
          <Grid
            container
            className="table-actions-row"
            justifyContent={"space-between"}
            sx={{ padding: "2px 0px", alignItems: "center" }}
          >
            <Grid item>
              <RadioGroup
                row
                aria-label="position"
                name="position"
                padding={10}
                sx={{ marginTop: 0.7 }}
                value={table}
                onChange={(e) => {
                  setTable(e.target.value);
                  dispatch(setTableUse(e.target.value));
                }}
                defaultValue="top"
              >
                <FormControlLabel
                  value="cardView"
                  control={<Radio />}
                  label="Card View"
                />
                <FormControlLabel
                  value="gridView"
                  control={<Radio />}
                  label="List View"
                />
              </RadioGroup>
            </Grid>
            <Grid display={"flex"}>
              {props.back && (
                <Grid item>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      gap: 1,
                      width: "100%",
                      padding: "8px 16px",
                      mr: 2,
                    }}
                    onClick={() => navigate(props.back)}
                  >
                    <IconButton className="" style={{ color: "#6ebe44" }}>
                      <IoIosArrowRoundBack />
                    </IconButton>
                    <Typography
                      variant="body1"
                      className="backcustom"
                      style={{ color: "#6ebe44" }}
                    >
                      Back
                    </Typography>
                  </Box>
                </Grid>
              )}
              {props?.add && (
                <Grid item mt={1}>
                  <Button
                    className="custombutton"
                    variant="contained"
                    onClick={() => navigate(props?.add)}
                    sx={{ background: "#6EBE44" }}
                  >
                    {props.buttonText ? props.buttonText : "Add"}
                  </Button>
                </Grid>
              )}
              {props?.customButton && <>{props?.customButton}</>}
            </Grid>
          </Grid>
          <Grid item lg={12}>
            <Grid container columnSpacing={1.5} sx={{ padding: "10px" }}>
              {tabs &&
                tabs.map((data) => {
                  return (
                    <Grid item key={data.title}> {/* Added key for map */}
                      <Tabs
                        title={data.title}
                        active={data.title === active?.title}
                        onClick={() => handleTabChange(data)}
                      />
                    </Grid>
                  );
                })}
              {filterTabs && <Grid item>{filterTabs}</Grid>}
              {!active?.customUi ? (
                <>
                  {" "}
                  {!table === "gridView" && (
                    <>
                      <Grid item lg={1} px={2}>
                        <Button
                          className="custombutton"
                          variant="outlined"
                          onClick={() => setShowSort(!showSort)}
                        >
                          {" "}
                          Sort
                        </Button>
                      </Grid>
                      {showSort && (
                        <>
                          <Grid item lg={2}>
                            <FormControl fullWidth>
                              <InputLabel
                                id="work-type-status-select-label"
                                style={{ fontSize: "14px" }}
                              >
                                Select Field
                              </InputLabel>
                              <Select
                                labelId="work-type-status-select-label"
                                id="work-type-status-select"
                                label="Work Type Status"
                                value={values.FIELD}
                                onChange={handleShortChange("FIELD")}
                              >
                                {column.map(
                                  (val) =>
                                    val.name !== "Actions" && (
                                      <MenuItem
                                        key={val.valuesName}
                                        value={val.valuesName}
                                      >
                                        {val.name}
                                      </MenuItem>
                                    )
                                )}
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid item lg={2}>
                            <FormControl fullWidth>
                              <InputLabel
                                id="work-type-status-select-label"
                                style={{ fontSize: "14px" }}
                              >
                                Select Sorting Type
                              </InputLabel>
                              <Select
                                labelId="work-type-status-select-label"
                                id="work-type-status-select"
                                label="Work Type Status"
                                value={values.DIRECTION}
                                onChange={handleShortChange("DIRECTION")}
                              >
                                <MenuItem value="ASC">ASC</MenuItem>
                                <MenuItem value="DESC">DESC</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                        </>
                      )}
                    </>
                  )}
                 <Grid
  container
  display="flex"
  justifyContent="end"
  className="search-input-col"
  style={{ marginTop: "10px" }}
  spacing={2}
>
  {props?.options && (
    <Grid item xs={4} md={4}>
      {props.options}
    </Grid>
  )}

  {filter && (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Grid container item spacing={2} xs={6} md={6}>
        {/* Start Date */}
        <Grid item xs={6}>
          <DatePicker
            value={startDate}
            onChange={(newValue) => {
              setStartDate(newValue);
              if (endDate && newValue && newValue.isAfter(endDate)) {
                setEndDate(null);
              }
            }}
            slotProps={{
              textField: {
                placeholder: "Start Date",
                size: "small",
                fullWidth: true,
                sx: {
                  "& .MuiOutlinedInput-input": {
                    padding: 1, // same as search
                  },
                },
                InputProps: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <RiCalendar2Line />
                    </InputAdornment>
                  ),
                },
              },
            }}
          />
        </Grid>

        {/* End Date */}
        <Grid item xs={6}>
          <DatePicker
            value={endDate}
            minDate={startDate}
            onChange={(newValue) => setEndDate(newValue)}
            slotProps={{
              textField: {
                placeholder: "End Date",
                size: "small",
                fullWidth: true,
                sx: {
                  "& .MuiOutlinedInput-input": {
                    padding: 1,
                  },
                },
                InputProps: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <RiCalendar2Line />
                    </InputAdornment>
                  ),
                },
              },
            }}
          />
        </Grid>
      </Grid>
    </LocalizationProvider>
  )}

  {/* Search Input */}
  {!hideSearchBox && (
    <Grid item xs={filter ? 3 : 4} md={filter ? 3 : 4}>
      <TextField
        placeholder="Search"
        variant="outlined"
        size="small"
        fullWidth
        sx={{
          "& .MuiOutlinedInput-root": {
            height: 46,
          },
          "& .MuiOutlinedInput-input": {
            padding: 1,
          },
        }}
        value={searchValues}
        onChange={(e) => setSearchValues(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <RiSearchLine />
            </InputAdornment>
          ),
        }}
      />
    </Grid>
  )}

  {/* Reset Button */}
  {(filter || !hideSearchBox) && (
    <Grid item xs="auto" md="auto">
      <Button
        className="custombutton"
        variant="outlined"
        onClick={handleResetFilters}
        sx={{
          color: "#6ebe44",
          borderColor: "#6ebe44",
          height: 46,
          "&:hover": {
            borderColor: "#6ebe44",
            backgroundColor: "#f0f0f0",
          },
        }}
      >
        Reset
      </Button>
    </Grid>
  )}
</Grid>

                </>
              ) : (
                <>{tabs[0]?.element}</>
              )}
            </Grid>
            {table === "gridView" && !active?.customUi && (
              <>
                {query.isLoading ? (
                  <GridSkeleton
                    columns={active?.column ? active.column : column}
                  />
                ) : (
                  <>
                    <DataTable
                      className="table-items"
                      columns={active?.column ? active?.column : column}
                      data={query?.data?.OUTPUT}
                      onSort={handleSort}
                      sortServer
                    />
                    <Grid item>
                      <CustomPagination
                        pagination={pagination}
                        count={pagination?.totalItems}
                        rowsPerPage={pagination.rowsPerPage}
                        page={pagination.page - 1}
                        setPage={(newPage) => {
                          setPagination((prev) => ({
                            ...prev,
                            page: newPage + 1,
                          }));
                        }}
                        onChangePage={(newPage) => {
                          setPagination((prev) => ({
                            ...prev,
                            page: newPage + 1,
                          }));
                        }}
                        onChangeRowsPerPage={(rowsPerPage) =>
                          setPagination((prev) => ({
                            ...prev,
                            rowsPerPage,
                            page: 1,
                          }))
                        }
                      />
                    </Grid>
                  </>
                )}
              </>
            )}
          </Grid>
        </Grid>
        {table === "cardView" && !active?.customUi && (
          <Grid
            className="gridcard grid_card_data clinicians-card-row"
            px={1.5}
            py={4}
            container
            columnSpacing={2.5}
            rowSpacing={3.5}
            style={{ overflowY: "auto" }}
          >
            {isLoading ? (
              <CardSkeleton />
            ) : (
              <>
                {data?.pages?.[0]?.OUTPUT?.length === 0 ? (
                  <Grid
                    item
                    xs={12}
                    style={{ textAlign: "center", width: "100%" }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontStyle: "normal",
                        fontWeight: 400,
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#000000",
                      }}
                    >
                      There are no records to display
                    </Typography>
                  </Grid>
                ) : (
                  data?.pages
                    .flatMap((page) => page.OUTPUT)
                    .map((val, index) => (
                      <Grid item ref={ref} lg={4} key={index}>
                        {CardViewCustomUi ? (
                          CardViewCustomUi(val)
                        ) : (
                          <Card
                            className="clinician-cards-col"
                            sx={{
                              borderRadius: 1,
                              boxShadow: "2px 2px 3px 3px #4CAF50",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-between",
                              minHeight: "180px",
                            }}
                          >
                            <>
                              {column?.map((col, colIndex) => (
                                <div key={colIndex}> {/* Added key for the fragment */}
                                  {col?.heading && !col?.button && (
                                    <Typography
                                      variant="h6"
                                      fontWeight="bold"
                                    >
                                      {col?.selector(val)}
                                    </Typography>
                                  )}
                                  {col?.status && !col?.button && (
                                    <Typography
                                      variant="h6"
                                      fontWeight="bold"
                                      mt={1}
                                    >
                                      <span
                                        style={{
                                          background: "#d2fbe5",
                                          color: "green",
                                          padding: "5px 10px",
                                          borderRadius: "20px",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          maxWidth: "150px",
                                        }}
                                      >
                                        {col?.selector(val)}
                                      </span>
                                    </Typography>
                                  )}
                                  {!col.status &&
                                    !col.heading &&
                                    !col?.button && (
                                      <Grid mt={1}>
                                        <div
                                          className="dflex"
                                          style={{ width: "100%" }}
                                        >
                                          <div style={{ width: "30%" }}>
                                            <p
                                              className="inter-family bold"
                                              style={{ fontSize: "11.4px" }}
                                            >
                                              {col.name}
                                            </p>
                                          </div>
                                          <div style={{ width: "50%" }}>
                                            <p
                                              className="inter-family"
                                              style={{
                                                fontSize: "11.4px",
                                                whiteSpace: "normal",
                                                wordWrap: "break-word",
                                                overflowWrap: "break-word",
                                                paddingLeft: "11px",
                                              }}
                                            >
                                              {typeof col?.selector === 'function' && col.selector(val, index)}
                                            </p>
                                          </div>
                                        </div>
                                      </Grid>
                                    )}
                                  {col?.button && (
                                    <div
                                      key={col.name}
                                      style={{
                                        display: "flex",
                                        justifyContent: "end",
                                        marginTop: 2,
                                      }}
                                    >
                                      {col.cell ? col.cell(val) : null}
                                    </div>
                                  )}
                                </div>
                              ))}
                            </>
                          </Card>
                        )}
                      </Grid>
                    ))
                )}
              </>
            )}
          </Grid>
        )}
      </Card>
    </>
  );
});

export default CustomTable;